module.exports = __webpack_public_path__ + "static/media/br-pa.c8a7e1d8.svg";